import { SET_BREADCRUMBS, emptyBredcrumbs } from './types';
const initialState = emptyBredcrumbs;
// eslint-disable-next-line import/prefer-default-export
export function breadcrumbsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_BREADCRUMBS:
            return Object.assign(Object.assign({}, state), action.payload);
        default:
            return state;
    }
}
// const factory = (fn: any) => (obj?: any) => {
//   if (!obj) return [];
//   return fn(obj).filter((item: any) => !!item);
// };
// export default {
//   // recommendations
//   '/specialty/recommendations/:anything': factory(() => [{ description: 'Recommendations', url: '/specialty/recommendations' }]),
//   '/specialty/recommendations/:recommendation_id': factory((recommendation: any) => [
//     { url: '/specialty/recommendations', description: 'Recommendations' },
//     { description: recommendation.name },
//   ]),
//   // surveys
//   '/specialty/surveys/:anything': factory(() => [{ description: 'Surveys', url: '/specialty/surveys' }]),
//   '/specialty/surveys/:id/recommendations': factory((survey: any) => [
//     { url: '/specialty/surveys', description: 'Surveys' },
//     !!survey && {
//       url: `/specialty/surveys/${survey.id}`,
//       description: survey.name,
//     },
//     { description: 'Recommendations' },
//   ]),
//   '/specialty/surveys/:id/cope': factory((survey: any) => [
//     { url: '/specialty/surveys', description: 'Surveys' },
//     !!survey && {
//       url: `/specialty/surveys/${survey.id}`,
//       description: survey.name,
//     },
//     { description: 'COPE' },
//   ]),
//   '/specialty/surveys/:id/loss-estimate': factory((survey: any) => [
//     { url: '/specialty/surveys', description: 'Surveys' },
//     !!survey && {
//       url: `/specialty/surveys/${survey.id}`,
//       description: survey.name,
//     },
//     { description: 'Loss Estimate' },
//   ]),
//   '/specialty/surveys/:id/recommendations/:recommendation_id': factory(({ survey, recommendation }: any) => [
//     { url: '/specialty/surveys', description: 'Surveys' },
//     !!survey && {
//       url: `/specialty/surveys/${survey.id}`,
//       description: survey.name,
//     },
//     !!survey && {
//       url: `/specialty/surveys/${survey.id}/recommendations`,
//       description: 'Recommendations',
//     },
//     !!survey &&
//       !!recommendation && {
//         url: `/specialty/surveys/${survey.id}/recommendations/${recommendation.id}`,
//         description: recommendation.name,
//       },
//   ]),
//   '/specialty/surveys/:id': factory((survey: any) => [{ url: '/specialty/surveys', description: 'Surveys' }, { description: survey.name }]),
//   // sites
//   '/specialty/sites/:anything': factory(() => [{ description: 'Sites', url: '/specialty/sites' }]),
//   '/specialty/sites/create': factory(() => [{ url: '/specialty/sites', description: 'Sites' }, { description: 'Create Site' }]),
//   '/specialty/sites/:id/edit': factory((location: any) => [
//     { url: '/specialty/sites', description: 'Sites' },
//     !!location.id && {
//       url: `/specialty/sites/${location.id}`,
//       description: location.name,
//     },
//     { description: 'Edit Site Details' },
//   ]),
//   '/specialty/sites/:id/activity-record/:activity_id': factory(({ location, activity }: any) => [
//     { url: '/specialty/sites', description: 'Sites' },
//     !!location && { url: `/specialty/sites/${location.id}`, description: location.name },
//     !!location && { url: `/specialty/sites/${location.id}/activities`, description: 'Activities' },
//     !!activity && { description: activity.master_activity_template?.name },
//   ]),
//   '/specialty/sites/:id/recommendations/:recommendation_id': factory(({ location, recommendation }: any) => [
//     { url: '/specialty/sites', description: 'Sites' },
//     !!location && { url: `/specialty/sites/${location.id}`, description: location.name },
//     !!location && { url: `/specialty/sites/${location.id}/recommendations`, description: 'Recommendations' },
//     !!recommendation && { description: recommendation.name },
//   ]),
//   '/specialty/sites/:id/surveys/:survey_id': factory(({ location, survey }: any) => [
//     { url: '/specialty/sites', description: 'Sites' },
//     !!location && { url: `/specialty/sites/${location.id}`, description: location.name },
//     !!location && { url: `/specialty/sites/${location.id}/surveys`, description: 'Surveys' },
//     !!survey && { description: survey.name },
//   ]),
//   '/specialty/sites/:id/surveys': factory((location: any) => [
//     { url: '/specialty/sites', description: 'Sites' },
//     { url: '/specialty/sites/:id', description: location.name },
//     { description: 'Surveys' },
//   ]),
//   '/specialty/sites/:id/recommendations': factory((location: any) => [
//     { url: '/specialty/sites', description: 'Sites' },
//     { url: `/specialty/sites/${location.id}`, description: location.name },
//     { description: 'Recommendations' },
//   ]),
//   '/specialty/sites/:id/documents': factory((location: any) => [
//     { url: '/specialty/sites', description: 'Sites' },
//     { url: '/specialty/sites/:id', description: location.name },
//     { description: 'Documents' },
//   ]),
//   '/specialty/sites/:id/activities': factory((location: any) => [
//     { url: '/specialty/sites', description: 'Sites' },
//     { url: '/specialty/sites/:id', description: location.name },
//     { description: 'Activities' },
//   ]),
//   '/specialty/sites/:id/managers': factory((location: any) => [
//     { url: '/specialty/sites', description: 'Sites' },
//     { url: '/specialty/sites/:id', description: location.name },
//     { description: 'Site Managers' },
//   ]),
//   '/specialty/sites/:id': factory((location: any) => [{ url: '/specialty/sites', description: 'Sites' }, { description: location.name }]),
//   // activities
//   // '/specialty/activities/:anything': factory(() => [{ description: 'Activities', url: '/specialty/activities' }]),
//   // '/specialty/activities/list': factory((company: any) => [{ description: company?.name || '' }, { description: 'Activities', url: '/specialty/activities' }]),
//   '/specialty/activities': factory(({ company }: any) => [{ description: company?.name || '' }, { description: 'Group Activities' }]),
//   '/specialty/activities/list': factory(({ company }: any) => [{ description: company?.name || '' }, { description: 'List Activities' }]),
//   '/specialty/activity-record/:id': factory((activity: any) => [
//     { url: '/specialty/activities', description: 'Activities' },
//     !!activity.id && { url: `/specialty/activity-record/${activity.id}`, description: activity.master_activity_template?.name },
//   ]),
//   // issues
//   '/specialty/issues/:anything': factory(() => [{ description: 'Issues', url: '/specialty/issues' }]),
//   // users
//   // '/specialty/users/:anything': factory(() => [{ description: 'Users', url: '/specialty/users' }]),
//   '/specialty/users/create': factory(() => [{ url: '/specialty/users', description: 'Users' }, { description: 'Create User' }]),
//   '/specialty/users/edit/:id': factory((user: any) => [
//     { url: '/specialty/users', description: 'Users' },
//     !!user.id && {
//       url: `/specialty/users/${user.id}`,
//       description: `${user.first_name} ${user.second_name}`,
//     },
//     { description: 'Edit User' },
//   ]),
//   '/specialty/users/:id/activity-record/:activity_id': factory(({ user, activity }: any) => [
//     { url: '/specialty/users', description: 'Users' },
//     !!user && user.id && { url: `/specialty/users/${user.id}`, description: `${user.name}` },
//     !!user && { url: `/specialty/users/${user.id}/activities`, description: 'Activities' },
//     !!activity && { description: activity.master_activity_template?.name },
//   ]),
//   '/specialty/users/:id/activities': factory((user: any) => [
//     { url: '/specialty/users', description: 'Users' },
//     !!user.id && { url: `/specialty/users/${user.id}`, description: `${user.first_name} ${user.second_name}` },
//     { description: 'Activities' },
//   ]),
//   '/specialty/users/:id': factory((user: any) => [
//     { url: '/specialty/users', description: 'Users' },
//     !!user.id && { description: `${user.first_name} ${user.second_name}` },
//   ]),
//   // companies
//   '/specialty/company/edit/:id': factory((company: any) => [{ description: `${company.name}` }, { description: 'Edit Business Details' }]),
//   // dashboard
//   '/specialty': factory(({ company }: any) => [
//     {
//       // url: `/specialty/company/edit/${company?.id || ''}`,
//       exact: true,
//       description: company?.name || '',
//     },
//   ]),
// };
